"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageVisibilityWriter = void 0;
const hidden_imageVisibility_1 = require("../imageVisibility/hidden.imageVisibility");
function writeHiddenImageVisibility(imageVisibility) {
    const state = imageVisibility.state;
    const hidden = state.hidden;
    return {
        id: state.id,
        tag: 'hidden',
        hidden,
    };
}
class ImageVisibilityWriter {
    static write(imageVisibility) {
        if (hidden_imageVisibility_1.CollectionModelHiddenImageVisibility.isHidden(imageVisibility)) {
            return writeHiddenImageVisibility(imageVisibility);
        }
        throw new Error(`Unexpected drawable: ${imageVisibility.id}:${imageVisibility.state.tag}`);
    }
}
exports.ImageVisibilityWriter = ImageVisibilityWriter;
//# sourceMappingURL=collection.model.write.imageVisibility.js.map